import type { TradingMode } from './App';

export const tradingPaths: Record<TradingMode, string> = {
  home: '/', swap: '/swap', futures: '/futures', cfd: '/cfd',
  prop_firm: '/prop-firm', robot: '/robot', events: '/events', wallet: '/wallet',
  profile: '/profile', staking: '/staking', wheel: '/wheel', payment_sandbox: '/payment-sandbox',
};

export function tradingModeForPath(pathname: string): TradingMode {
  const path = pathname.replace(/\/+$/, '') || '/';
  return (Object.keys(tradingPaths) as TradingMode[]).find(mode => tradingPaths[mode] === path) ?? 'home';
}
